import {useState} from 'react';

import {
  FontBoldSpan,
  FontBigBold,
  WrapperSpan,
  HoverTargetWrapperDiv,
  HiddenDropdownWrapperDiv,
  TopDiv,
  TipPositioning,
  SortingDropDownWrapper,
  RadioCheck,
} from './DropDownCheckList.styles';

import ArrowDownIcon from './../../../../Icons/ArrowDownIcon';

interface OptionType {
  name: string;
  value: string;
}

interface IDropdownList {
  options: Array<OptionType>;
  onHandleChange: Function;
  title: string;
  selOption: string;
  selOptionName: string;
  dataTestIdForTitle?: string;
  dataTestIdForOptions?: string;
  keyNameForOption?: string;
  keyNameForOptionName?: string;
}

const DropDownCheckList = ({
  options,
  onHandleChange,
  title,
  selOption = '',
  selOptionName = '',
  dataTestIdForTitle,
  dataTestIdForOptions,
  keyNameForOption = 'value',
  keyNameForOptionName = 'name',
}: IDropdownList) => {
  const [selectedOption, updateSelectedOption] = useState(selOption);
  const [selOpName, updateSelOptionName] = useState(selOptionName);

  const onChange = (value, name) => {
    updateSelectedOption(value);
    onHandleChange(value, name);
    updateSelOptionName(name);
  };

  return (
    <>
      <HoverTargetWrapperDiv data-testid={dataTestIdForTitle ? dataTestIdForTitle : ''}>
        <FontBoldSpan>{title}:</FontBoldSpan>
        <WrapperSpan>
          {selOpName}
          <ArrowDownIcon width="1rem" height="1rem" margin="0 0 0 0.5rem" />
        </WrapperSpan>
        <HiddenDropdownWrapperDiv data-testid={dataTestIdForOptions ? dataTestIdForOptions : ''}>
          <TopDiv>
            <SortingDropDownWrapper>
              <li>
                <FontBoldSpan>{title}</FontBoldSpan>
              </li>
              {options.map((item, i) => (
                <li
                  onClick={() => onChange(item[keyNameForOption], item[keyNameForOptionName])}
                  key={i}
                >
                  <RadioCheck
                    name={item[keyNameForOptionName]}
                    checked={selectedOption === item[keyNameForOption]}
                    readOnly
                  />
                  <FontBigBold>{item[keyNameForOptionName]}</FontBigBold>
                </li>
              ))}
            </SortingDropDownWrapper>
            <TipPositioning />
          </TopDiv>
        </HiddenDropdownWrapperDiv>
      </HoverTargetWrapperDiv>
    </>
  );
};

export default DropDownCheckList;
